/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Overall summary across all accounts
 */
export interface CloudCostMgmtOverallSummary { 
    /**
     * Total monthly cost across all accounts in USD
     */
    total_cost: number;
    /**
     * Total potential savings across all accounts in USD
     */
    potential_savings: number;
    /**
     * Total realized savings from cleaned resources across all accounts in USD
     */
    realized_savings: number;
    /**
     * Number of active accounts
     */
    active_accounts: number;
    /**
     * Total number of cleanup candidates
     */
    cleanup_candidates: number;
    /**
     * Total number of cleaned candidates
     */
    cleaned_candidates?: number;
}

